import React, { useEffect, useRef } from "react";
import { drawAvatar } from "../../lib/avatarDraw";

// Kanvas kecil berisi karakter (idle bernapas / berjalan / emote) — untuk bar atas, kartu pemain, dan pratinjau editor.
// `size` = tinggi kanvas px; karakter diskalakan agar pas (tinggi karakter ±50 unit pada scale 1).
export function AvatarCanvas({ av, size = 48, anim = true, emote, walking, bg, style, testid }) {
  const ref = useRef(null);
  useEffect(() => {
    const c = ref.current; if (!c || !av) return undefined;
    const dpr = Math.min(2, window.devicePixelRatio || 1), w = Math.round(size * 0.9), h = size;
    c.width = w * dpr; c.height = h * dpr; c.style.width = `${w}px`; c.style.height = `${h}px`;
    const ctx = c.getContext("2d");
    const s = (h - 8) / 52;
    let raf, t0 = performance.now();
    const gambar = () => {
      const t = (performance.now() - t0) / 1000;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, w, h);
      if (bg) { ctx.fillStyle = bg; ctx.beginPath(); ctx.roundRect(0, 0, w, h, Math.min(w, h) * 0.3); ctx.fill(); }
      drawAvatar(ctx, w / 2, h - 4, av, { scale: s, t, emote, walking });
      if (anim) raf = requestAnimationFrame(gambar);
    };
    gambar();
    return () => cancelAnimationFrame(raf);
  }, [av, size, anim, emote, walking, bg]);
  return <canvas ref={ref} data-testid={testid} style={{ display: "block", ...style }} aria-hidden />;
}
